var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'coupon-empty bg-color-secondary',
    { 'flex': _vm.isFlex }
]},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coupon-empty-body text-center"},[_c('header',{staticClass:"fs-40 fs-lh-60"},[_vm._v("\n            Dziękujemy za aktualizację danych!\n        ")]),_c('span',{staticClass:"fs-32 fs-lh-60 text-bold"},[_vm._v("\n            Zapraszamy na zakupy do MAKRO\n        ")])])}]

export { render, staticRenderFns }